const join = () =>
  import(/* webpackChunkName: "join" */ "./join.vue");

export default {
  name: "加盟清软",
  path: "/join",
  component: join,
  meta: {show:true,},
};
